import { FC } from 'react'
import { styles } from './ProRithmDasboard'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { selectPatientInfo, setPatientInfo } from './ProrithmSlice'
import { ProrithmSelectableSearch } from './ProrithmSelectableSearch'
import {
  messages,
  constants,
  IPD_SEARCH_TERMS,
  IpdSearchOptions,
} from './Constants'
import {
  Box,
  Paper,
  Table,
  useTheme,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import SelectedPatient from './SelectedPatient'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'

interface SearchByPatientProps {
  mapTo: string
  handleSearch: (query: string, param: string) => void
  data: IpdSearchOptions[] | null
}

const SearchByPatient: FC<SearchByPatientProps> = ({
  mapTo,
  handleSearch,
  data,
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const patientInfo = useAppSelector(selectPatientInfo)
  const dispatch = useAppDispatch()

  const rowData = [
    constants?.firstName,
    constants?.lastName,
    constants?.age,
    constants?.gender,
    constants?.phone,
  ]

  const isSelected = (row: IpdSearchOptions) =>
    patientInfo?.firstName === row?.firstName &&
    patientInfo?.lastName === row?.lastName &&
    patientInfo?.age === row?.age &&
    patientInfo?.gender === row?.gender &&
    patientInfo?.phoneNumber === row?.phoneNumber &&
    patientInfo?.muhId === row?.muhId

  const handleCheckboxChange = (checked: boolean, row: IpdSearchOptions) => {
    if (checked) {
      dispatch(setPatientInfo(row))
    } else {
      dispatch(setPatientInfo(null))
    }
  }

  return (
    <Box marginBottom={2}>
      <ProrithmSelectableSearch
        items={IPD_SEARCH_TERMS}
        onSearch={handleSearch}
        placeHolder='Search by Name, Phone, MUHID'
      />
      {data ? (
        <>
          {data.length > 0 ? (
            <>
              {!patientInfo && (
                <Typography variant='caption' fontWeight='bold'>
                  {constants?.selectPatient}
                </Typography>
              )}
              <Box className={classes.reportsTable}>
                <TableContainer component={Paper}>
                  <Table size='small'>
                    <TableHead>
                      <TableRow>
                        {rowData?.map((value) => (
                          <TableCell key={crypto.randomUUID()}>
                            {value}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data?.map((row: IpdSearchOptions) => (
                        <TableRow
                          hover
                          key={row?.muhId}
                          selected={isSelected(row)}
                        >
                          <TableCell>
                            <Checkbox
                              size='small'
                              checked={isSelected(row)}
                              onChange={(event) =>
                                handleCheckboxChange(
                                  event?.target?.checked,
                                  row
                                )
                              }
                            />
                            {row?.firstName}
                          </TableCell>
                          <TableCell>{row?.lastName}</TableCell>
                          <TableCell>{row?.age}</TableCell>
                          <TableCell>{row?.gender}</TableCell>
                          <TableCell>{row?.phoneNumber}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          ) : (
            <Typography variant='body2' fontStyle='italic'>
              {mapTo === constants?.ipd
                ? messages?.noPatientInIpd
                : messages?.noPatient}
            </Typography>
          )}
        </>
      ) : null}
      <SelectedPatient mapTo={mapTo} />
    </Box>
  )
}

export default SearchByPatient
